
import { mapGetters } from 'vuex'

export default {
  name: 'WorkspaceLabel',
  props: {
    isAddedToWorkSpace: {
      type: Boolean,
      default: false,
      required: true,
    },
    folderName: {
      type: String,
      default: null,
    },
    productDistributorId: {
      type: Number,
      default: null,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      hasOnlyRootFolder: 'inventory/hasOnlyRootFolder',
    }),
    iconColor() {
      return this.isAddedToWorkSpace ? 'yellow_01' : 'grayDark_02'
    },
    hasOnlyRootFolderAndAdded() {
      return this.hasOnlyRootFolder && this.isAddedToWorkSpace
    },
  },
  watch: {
    isAddedToWorkSpace: {
      immediate: true,
      deep: true,
      handler(isAdded) {
        this.isAddedToWorkspace = isAdded
      },
    },
  },
  methods: {
    clickHandler() {
      if (this.hasOnlyRootFolder) {
        if (this.isAddedToWorkSpace) return false

        this.$emit('on-add-to-root-folder', {
          productDistributorId: this.productDistributorId,
        })
      } else {
        this.$emit('on-show-add-to-inventory-dialog')
      }
    },
  },
}
